import React from "react";
import Sidebar from "../../Navigation/Sidebar/Sidebar";
import leftArrow from "../../../assests/leftArrow.svg";
import editIcon from "../../../assests/bosEdit.svg";
// import deleteIcon from "../../../assests/delete.svg";
import LoadingSpinner from "../../Loading/component";
import "./ProductCategories.css";

const ProductCategoriesComponent = ({
  categories = [],
  loading,
  searchTerm,
  setSearchTerm,
  onCreateCategory,
  onEditCategory,
  onDeleteCategory,
  onCategoryClick,
  canPerformActions,
}) => {
  const handleBackClick = () => {
    window.history.back();
  };

  // S3 Base URL
  const S3_BASE_URL = "https://s3.ap-south-1.amazonaws.com/daalchini/dcprod/";
  const DEFAULT_IMAGE = "https://images.unsplash.com/photo-1505740420928-5e560c06d30e?w=400&h=400&fit=crop";

  // Get full image URL
  const getFullImageUrl = (imagePath) => {
    if (!imagePath) return DEFAULT_IMAGE;
    if (imagePath.startsWith("http://") || imagePath.startsWith("https://")) {
      return imagePath;
    }
    return `${S3_BASE_URL}${imagePath}`;
  };

  if (loading) {
    return (
      <div className="categories-container">
        <Sidebar />
        <div className="categories-content">
          <div className="full-page-loader">
            <LoadingSpinner />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="categories-container">
      <Sidebar />
      
      <div className="categories-content">
        {/* Header */}
        <div className="categories-header">
          <button onClick={handleBackClick} className="back-btn">
            ←
          </button>
          <h1>Product Categories</h1>
        </div>

        {/* Search Section */}
        <div className="categories-search-section">
          <div className="categories-search-wrapper">
            {/* <svg className="categories-search-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="11" cy="11" r="8"></circle>
              <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
            </svg> */}
            <input
              type="text"
              placeholder="Search category by Name..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="categories-search-input"
            />
          </div>
        </div>

        {/* Categories Grid - Scrollable */}
        <div className="categories-grid-wrapper">
          <div className="categories-grid">
            {/* Create New Category Card - First Card */}
            {canPerformActions && (
              <div 
                className="category-card create-card"
                onClick={onCreateCategory}
              >
                <div className="create-card-content">
                  <div className="plus-icon-wrapper">
                    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <line x1="12" y1="5" x2="12" y2="19"></line>
                      <line x1="5" y1="12" x2="19" y2="12"></line>
                    </svg>
                  </div>
                  <div className="create-card-text">Create New Category</div>
                </div>
              </div>
            )}

            {/* Existing Categories */}
            {categories.length === 0 ? (
              <div className="no-categories">
                <div className="no-data-icon">📦</div>
                <p>No categories found</p>
                <small>Create a new category to get started</small>
              </div>
            ) : (
              categories.map((category) => {
                const imageUrl = getFullImageUrl(category.image_url || category.image);
                const isInactive = category.status === "Inactive";
                
                return (
                  <div 
                    key={category.id} 
                    className={`category-card ${isInactive ? 'inactive-card' : ''}`}
                    onClick={() => onCategoryClick(category)}
                  >
                   
                    {canPerformActions && (
                      <div className="category-card-actions">
                        <button 
                          className="action-icon edit-icon"
                          onClick={(e) => {
                            e.stopPropagation();
                            onEditCategory(category);
                          }}
                          title="Edit Category"
                        >
                          <img src={editIcon} alt="Edit" />
                        </button>
                        {/* <button 
                          className="action-icon delete-icon"
                          onClick={(e) => {
                            e.stopPropagation();
                            onDeleteCategory(category);
                          }}
                          title="Delete Category"
                        >
                          <img src={deleteIcon} alt="Delete" />
                        </button> */}
                      </div>
                    )}

                    {/* Category Image */}
                    <div className="category-card-image">
                      <img 
                        src={imageUrl} 
                        alt={category.name}
                        onError={(e) => {
                          e.target.src = DEFAULT_IMAGE;
                        }}
                      />
                    </div>

                    {/* Category Name */}
                    <div className="category-card-name">
                      {category.name}
                    </div>

                    {/* Category Description */}
                    {/* {category.description && (
                      <div className="category-description">
                        {category.description.length > 50 
                          ? category.description.substring(0, 50) + "..." 
                          : category.description}
                      </div>
                    )} */}

                    {/* Subcategory Count */}
                    {category.subCategories && category.subCategories.length > 0 && (
                      <div className="subcategory-count">
                        {category.subCategories.length} Subcategories
                      </div>
                    )}
                  </div>
                );
              })
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductCategoriesComponent;